import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Segment, Header, Form, Icon, Button, Grid } from 'semantic-ui-react';

import { renewalGridColumns } from './columns';
import {
    loadRenewalGridData,
    hideRenewalGridColumn,
    toggleRenewalGridControl,
    changeRenewalGridServiceLevel,
} from './actions';

import SelectedCompanyBadge from '../containers/selected-badge';
import CompanyComponentServiceFilter from '../components/service-filter';
import GridColumnPicker from '../../common/components/grid-column-picker';

const RenewalGridControl = ({
    hiddenColumns, selectedCompany, history, showControl, serviceLevel, isLoading, filterModel,
    hideRenewalGridColumn, toggleRenewalGridControl, loadRenewalGridData, changeRenewalGridServiceLevel, resetFilters, onDownload
}) => {
    if (!showControl) {
        return (
            <Segment vertical clearing>
                <SelectedCompanyBadge />

                {!!selectedCompany && (
                    <Button
                        compact
                        size="tiny"
                        color="teal"
                        content="Edit"
                        onClick={() => history.push(`/company/${selectedCompany.id}/edit`)}
                    />
                )}

                <Button
                    size="mini"
                    floated="right"
                    onClick={toggleRenewalGridControl}
                >
                    Configure Grid
                </Button>

                <Button
                    size="mini"
                    icon="refresh"
                    floated="right"
                    loading={isLoading}
                    onClick={() => loadRenewalGridData({service: serviceLevel})}
                />

                <Button
                    size="mini"
                    icon="download"
                    floated="right"
                    onClick={onDownload}
                />

                {!isEmpty(filterModel) && (
                    <Button
                        size="mini"
                        icon="filter"
                        content="Clear"
                        floated="right"
                        onClick={resetFilters}
                    >
                    </Button>
                )}

                <CompanyComponentServiceFilter
                    grid="renewal"
                    isLoading={isLoading}
                    serviceLevel={serviceLevel}
                    onChange={changeRenewalGridServiceLevel}
                    dropdownProps={{
                        button: true,
                        pointing: "top",
                        className: "right floated mini"
                    }}
                />
            </Segment>
        );
    }

    return (
        <Segment vertical>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={12}>
                        <Header>
                            <Icon name="dollar" />
                            <Header.Content>
                                Renewal Grid
                                <Header.Subheader>
                                    Configure The Grid, select a company to see their details, settings etc.
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Button
                            size="mini"
                            floated="right"
                            onClick={toggleRenewalGridControl}
                        >
                            Hide
                        </Button>
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            <Form className="tm-15">
                <Form.Group>
                    <Form.Field width={8}>
                        <label>Select Columns to Hide</label>
                        <GridColumnPicker
                            onChange={hideRenewalGridColumn}
                            hiddenColumns={hiddenColumns}
                            columns={renewalGridColumns}
                        />
                    </Form.Field>
                    <Form.Field width={3}>
                        <label>Subscription</label>
                        <CompanyComponentServiceFilter
                            dropdownProps={{ fluid: true, selection: true }}
                            onChange={changeRenewalGridServiceLevel}
                            serviceLevel={serviceLevel}
                            isLoading={isLoading}
                            grid="renewal"
                        />
                    </Form.Field>
                    <Form.Field width={5} disabled={!selectedCompany}>
                        <label>Actions</label>
                        <SelectedCompanyBadge />
                        <Button
                            compact
                            size="tiny"
                            color="teal"
                            content="Edit"
                            onClick={() => history.push(`/company/${selectedCompany.id}/edit`)}
                        />
                        
                        <Button
                            size="tiny"
                            icon="filter"
                            content="Clear"
                            onClick={resetFilters}
                            disabled={isEmpty(filterModel)}
                        >
                        </Button>
                    </Form.Field>
                </Form.Group>
            </Form>
        </Segment>
    );
};

const mapStateToProps = ({ companyRenewalGrid, companyUsageGrid }) => ({
    hiddenColumns: companyRenewalGrid.hiddenColumns,
    serviceLevel: companyRenewalGrid.serviceLevel,
    showControl: companyRenewalGrid.showControl,
    filterModel: companyRenewalGrid.filterModel,
    isLoading: companyRenewalGrid.isLoading,

    selectedCompany: companyUsageGrid.selected,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    loadRenewalGridData,
    hideRenewalGridColumn, 
    toggleRenewalGridControl, 
    changeRenewalGridServiceLevel,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RenewalGridControl));